module.exports = __webpack_public_path__ + "static/media/ic_people_active.37820bf0.svg";